<dx-popup
  [(visible)]="displayDialog"
  [showTitle]="true"
  [title]="'Modification de masse — ' + (providerCode | uppercase)"
  [width]="600"
  [height]="'auto'"
  (onHidden)="closeDialog()">

  <div *dxTemplate="let data of 'content'">

    <div class="mg-b-10">
      <span class="genlabel">{{ connectionList.length }} configuration(s) sélectionnée(s)</span>
    </div>

    <div class="dialog-line">
      <div class="label">Flux abonnés</div>
      <div class="value">
        <yo-tagbox
          [data]="fluxList"
          [selectedItems]="selectedFluxList"
          (onValueChange)="selectedFluxList = $event">
        </yo-tagbox>
      </div>
    </div>

    <div class="mg-t-10 font-12 font-italic">
      Les flux sélectionnés définissent l'état final pour toutes les configurations. Les flux non sélectionnés mais actuellement abonnés seront retirés.
    </div>

    <div class="d-flex mg-t-15 justify-content-end">
      <yo-button
        class="mg-r-5"
        label="Enregistrer"
        iconClass="fas fa-save"
        [theme]="ButtonThemeEnum.ADD"
        [disabled]="isSaving"
        (onClick)="save()">
      </yo-button>
      <yo-button
        label="Annuler"
        iconClass="fas fa-times"
        [theme]="ButtonThemeEnum.CANCEL"
        (onClick)="closeDialog()">
      </yo-button>
    </div>

  </div>
</dx-popup>
